import React from "react";
import Navbar2 from "../Components/Navbar2";
import Footer from "../Components/Footer";

function EventCalendar() {
  return (
    <>
      <Navbar2 />
      <div>
        EventCalendar
      </div>
      <Footer />
    </>
  );
}

export default EventCalendar;
